import React, { useEffect, useRef, useState, useCallback } from "react";
import "./InfoIcon.scss";

function InfoIcon({ label, altStyle= true }) {
	const [active, setActive] = useState(false);
	const popupRef = useRef(null);
	const iconRef = useRef(null);

	function toggleActive(e) {
		e.stopPropagation();
		setActive(!active);
	}

	// Close popup when clicking outside
	const handleClickOutside = useCallback((e) => {
		if (iconRef.current && !iconRef.current.contains(e.target)) {
			setActive(false);
		}
	}, []);

	useEffect(() => {
		if (active) {
			document.addEventListener("click", handleClickOutside);
			document.addEventListener("touchstart", handleClickOutside);
		}
		return () => {
			document.removeEventListener("click", handleClickOutside);
			document.removeEventListener("touchstart", handleClickOutside);
		};
	}, [active, handleClickOutside]);

	useEffect(()=>{
		repositionPopup();
		window.addEventListener("resize", repositionPopup);
		return () => window.removeEventListener("resize", repositionPopup);
	},[active]);

	function repositionPopup(){
		if(popupRef.current) {
			popupRef.current.style.top = `-${ (popupRef.current.offsetHeight / 2) - 5 }px`;
		}
	}


	return (
		<span ref={iconRef} className={`info-icon ${active ? " active" : ""}`} onClick={toggleActive}>
			<span className="mini"></span>
			<span ref={popupRef} className="popup" style={altStyle && {fontSize: "12px", maxWidth: "200px", minWidth: "150px", zIndex: 1000,}}>{label}</span>
		</span>
	);
}

export default InfoIcon;
